/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React from "react";
import Modal from "shared/components/Modal";
import { ERROR_MESSAGES } from "constants/errorMessages";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { logger } from "logging";
import { FilledButton } from "@nykaa/payment-ui/src/Button";
import { Image } from "@nykaa/payment-ui/src/Image";


interface ErrorBoundaryProps {
  children: React.ReactNode;
  message: string;
  theme: Theme;
}
interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  public state = { hasError: false };

  componentDidCatch(error: Error) {
    logger.error(error);
    this.setState({
      hasError: true,
    });
  }

  render() {
    const { hasError } = this.state;
    const { message, theme } = this.props;
    const errorMessage = message ? message : "Something went wrong";
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <Modal
            isVisible={true}
            onHide={() => window.location.reload()}
            zIndex={3}
            zIndexOverlay={2}
            isPartial
            modalContentClass="pt10 prl10 error-modal"
          >
            <div className="ptb10 text-center server-error-popup">
              <i className="mb10 icon">
                <Image url={getIcons(__PLATFORM__ || "", ICONS_NAMES.ALERT)} alt={"error"} theme={theme}/>
              </i>
              <p className="mb0 font-semibold font-size-16">{errorMessage}</p>
              <p className="m0 ptb10 prl10 font-size-12 error-msg">
                {ERROR_MESSAGES.PAYMENT_INTERNAL_ISSUE}
              </p>
              <FilledButton
                text={"Reload"}
                onClick={() => window.location.reload()}
                font={theme.typography.buttonSmall}
                color={theme.colors.surface}
                theme={theme}
              />
            </div>
          </Modal>
        </>
      );
    }

    return <>{this.props.children}</>;
  }
}
